/**
 * @generated SignedSource<<2a8a3ca7175127a4caef1f2a3b5a54bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskMultipleRenderTaskContent_taskExecution$data = {
  readonly __typename: "TaskExecutionCheck";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck">;
  readonly " $fragmentType": "WidgetTaskMultipleRenderTaskContent_taskExecution";
} | {
  readonly __typename: "TaskExecutionNumber";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber">;
  readonly " $fragmentType": "WidgetTaskMultipleRenderTaskContent_taskExecution";
} | {
  readonly __typename: "TaskExecutionText";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTaskText_taskExecutionText">;
  readonly " $fragmentType": "WidgetTaskMultipleRenderTaskContent_taskExecution";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "WidgetTaskMultipleRenderTaskContent_taskExecution";
};
export type WidgetTaskMultipleRenderTaskContent_taskExecution$key = {
  readonly " $data"?: WidgetTaskMultipleRenderTaskContent_taskExecution$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTaskContent_taskExecution">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskMultipleRenderTaskContent_taskExecution",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck"
        }
      ],
      "type": "TaskExecutionCheck",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber"
        }
      ],
      "type": "TaskExecutionNumber",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTaskMultipleRenderTaskText_taskExecutionText"
        }
      ],
      "type": "TaskExecutionText",
      "abstractKey": null
    }
  ],
  "type": "TaskExecution",
  "abstractKey": "__isTaskExecution"
};
})();

(node as any).hash = "a508cd2949d6ef66be8ebe208fd27103";

export default node;
